/* ============================================================================
   INBAR+co PDP Auto-Open Drawer Hook
   ============================================================================
   Opens the cart drawer when a product is added from a product page.
   Listens for both legacy 'cart:add' and Prestige's 'variant:add' events.

   Why this exists: Prestige has built-in logic for auto-open but it can
   conflict with our re-render flow in inbar-cart-drawer.js. This hook is
   independent and guaranteed to fire after a successful ATC.

   Loads on every page but only does work when:
     - <cart-drawer id="cart-drawer"> exists in DOM
     - A variant was successfully added (no error)
   ============================================================================ */

(function () {
  'use strict';

  // Small delay so Prestige's cart-change handler can re-render content first
  const OPEN_DELAY_MS = 50;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Listen for cart change events. Different code paths dispatch different
    // events, so we listen for all of them.
    //   - 'variant:add'  — Prestige's standard product form
    //   - 'cart:add'     — generic fallback
    //   - 'cart:open'    — INBAR custom PDP (ic-product.js icAddToCart)
    //   - 'cart:refresh' — also dispatched by ic-product.js as a secondary signal
    document.addEventListener('variant:add', handleAddEvent);
    document.addEventListener('cart:add', handleAddEvent);
    document.documentElement.addEventListener('cart:open', handleAddEvent);
    document.documentElement.addEventListener('cart:refresh', handleAddEvent);
  }

  function handleAddEvent(event) {
    // Only fire on success
    if (event && event.detail && event.detail.error) return;

    // Don't auto-open if we're already on the cart page (no point)
    if (window.location.pathname === '/cart') return;

    // Don't auto-open if the drawer is already open
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    if (drawer.hasAttribute('open')) return;

    // Open the drawer after a tiny delay (lets section re-render finish)
    setTimeout(function () {
      openDrawer(drawer);
    }, OPEN_DELAY_MS);
  }

  function openDrawer(drawer) {
    // Prestige's Drawer extends Modal which has a show() method
    if (typeof drawer.show === 'function') {
      drawer.show();
      return;
    }
    // Fallback: dispatch a custom event Prestige listens to
    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    // Last resort: just set the attribute
    drawer.setAttribute('open', '');
  }
})();